import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Text,
  Flex,
  Image,
} from "@chakra-ui/react";
import React, { useCallback, useContext, useEffect } from "react";
import { NotificationContext } from "../context/notificationContext";
import notificationSvg from "../assets/notifications.svg";

const OnboardingModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { onOpen: openNotificationCentre } = useContext(NotificationContext);

  useEffect(() => {
    // show modal only once on first time ever opening website
    if (localStorage.getItem("firstTime") === null) {
      onOpen();
    }
  }, [onOpen, onClose]);

  const handleClose = useCallback(() => {
    localStorage.setItem("firstTime", "false");
    onClose();
  }, [onClose]);

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Welcome to Roses Dashboard</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Image src={notificationSvg} w={"80%"} my={10} mx="auto" />
          <Text mb={3}>
            Turn on Roses-related notifications for your favourite sports using
            this web app.
          </Text>
          <Text mb={3}>
            You can find the notification centre by clicking the button below
          </Text>
        </ModalBody>

        <ModalFooter>
          <Flex>
            <Button
              colorScheme="blue"
              onClick={() => {
                handleClose();
                openNotificationCentre();
              }}
            >
              Take me to the notification centre
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default OnboardingModal;
